<template>
  <div class="wrapper">
    <form
      ref="form"
      class="form"
      @submit.prevent="loginUser">
      <p
        v-if="$store.state.Login.userInvalid"
        class="error">
        Try again, incorrect username or password.
      </p>
      <div
        v-for="(field, key) in fields"
        :key="key"
        class="field">
        <p
          class="field__label"
          v-html="field.label"></p>
        <input
          v-model="field.value"
          :type="field.type"
          class="field__input"
          required>
      </div>
      <div>
        <button
          class="submit"
          type="submit"
          v-text="loading ? 'Logging in...' : 'Submit'"></button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      fields: [
        // {
        //   label: 'Username',
        //   key: 'username',
        //   type: 'text',
        //   value: '',
        // },
        {
          label: 'Password',
          key: 'password',
          type: 'password',
          value: '',
        }],
      loading: false,
    };
  },
  watch: {
    '$store.state.Login.userInvalid': {
      handler(userInvalid) {
        if (userInvalid) {
          this.resetForm();
        }
      },
    },
  },
  methods: {
    resetForm() {
      this.fields.map(field => {
        field.value = '';
      });
    },
    validateFields() {
      return this.fields.every(field => field.value !== '');
    },
    cleanFields(fields) {
      return this.fields.reduce((obj, field) => {
        obj[field.key] = field.value;
        return obj;
      }, {});
    },
    loginUser() {
      if (this.validateFields()) {
        this.$store.dispatch('LOGIN_USER', {
          fields: this.cleanFields(this.fields),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  flex: 1;
  place-content: stretch;
  place-items: center;
  display: grid;
}

.form {
  max-width: 30rem;
  width: 100%;
}

.error,
.field {
  margin-bottom: 24px;
  width: 100%;
}

.field__label {
  margin-bottom: 0.25rem;
}

.field__input {
  border: solid 1px rgba(255, 255, 255, 0.8);
  color: #fff;
  line-height: 24px;
  padding: 1rem 1rem 0.875rem;
  width: 100%;

  &:focus {
    border: solid 1px white;
    outline: none;
  }
}

.submit {
  background: #000;
  border: 1px solid white;
  color: #fff;
  cursor: pointer;
  font-size: $font-size--body;
  padding: .875rem .75rem;

  &:focus {
    outline: none;
  }
}

</style>
